import { ArrowLeft } from '@phosphor-icons/react';
import { IconButton, Inline, Stack, Tooltip } from '@reelplicate/ui';
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router';

import { type FlowView, FlowViewSwitch } from './flow-view-switch';

/**
 * The bar above a flow's Runs and Results views (the editor has its own):
 * back to all flows, the name with a status chip, the view switch, an action.
 */
export function FlowPageHeader({
  flowId,
  title,
  chip,
  meta,
  view,
  action,
}: {
  flowId: string;
  title: string;
  chip?: ReactNode;
  meta?: string;
  view: FlowView;
  action?: ReactNode;
}) {
  const navigate = useNavigate();
  return (
    <header className="bg-bg-surface border-border-subtle grid h-15 shrink-0 grid-cols-[1fr_auto_1fr] items-center gap-2 border-b pr-4 pl-3">
      <Inline gap={2} className="min-w-0">
        <Tooltip content="All flows">
          <IconButton
            icon={ArrowLeft}
            aria-label="All flows"
            onClick={() => void navigate('/flows')}
          />
        </Tooltip>
        <Stack gap={0} className="min-w-0">
          <Inline gap={2} className="min-w-0">
            <h1 className="text-heading-h4 text-text-primary truncate">{title}</h1>
            {chip}
          </Inline>
          {meta && <p className="text-caption text-text-secondary truncate">{meta}</p>}
        </Stack>
      </Inline>
      <FlowViewSwitch flowId={flowId} view={view} />
      <Inline gap={2} align="right">
        {action}
      </Inline>
    </header>
  );
}
